export const COMMERCE_AGENT_URL = "https://redo.com/products/commerce-agent";
